// hexagonHover.tsx
import { FC } from "react";
export const HexagonHover: FC = () => (
  <div className="absolute -top-3 -right-3 w-6 h-6 opacity-0 group-hover:opacity-100 duration-300 group-hover:scale-125 transition-transform">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480">
      <defs>
        <linearGradient id="hex-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ff9900ff" />
          <stop offset="100%" stopColor="#c96c1bff" />
        </linearGradient>
      </defs>
      <path
        d="M360 32.2H120L0 240l120 207.9h240L480 240 360 32.2z"
        fill="url(#hex-gradient)"
      />
    </svg>
  </div>
);
